<template>
    <div id="widget-no-ui-slider"></div>
</template>

<script>
    import noUiSlider from "nouislider";
    import wNumb from "wnumb";
    import "nouislider/dist/nouislider.css";

    export default {
        name: "no-ui-slider",
        props: {
            value: {
                type: Number,
                required: true
            },
            max: {
                type: Number,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            disabled () {
                if (this.disabled) {
                    this.slider.setAttribute("disabled", true);
                } else {
                    this.slider.removeAttribute("disabled");
                }
            },
            value () {
                this.slider.noUiSlider.set(this.value);
            },
            max () {
                this.slider.noUiSlider.updateOptions({
                    range: {
                        "min": 0,
                        "max": this.max
                    },
                    start: this.value
                }, true);
            }
        },
        data () {
            return {
                slider: null
            };
        },
        mounted () {
            this.slider = document.getElementById("widget-no-ui-slider");

            noUiSlider.create(this.slider, {
                start: this.value,
                connect: "lower",
                step: 1,
                tooltips: wNumb({ decimals: 0, thousand: "," }),
                range: {
                    "min": 0,
                    "max": this.max
                }
            });

            this.slider.noUiSlider.on("change", (event) => {
                this.$emit("input", Number(event[0]));
                this.$emit("change");
            });
        }
    };
</script>
